import { ITinyCompanies } from '@core/interfaces/companies-items';
import { ITinyEntity } from '@core/interfaces/entity-items';
import { IInvoice } from '@core/interfaces/invoice';

export enum DigitalInvoiceTransmissionEventStatusEnum {
  Success = 'success',
  Submitted = 'submitted',
  Running = 'running',
  Error = 'error',
}

export const DigitalInvoiceTransmissionStatusOptions = [
  { key: DigitalInvoiceTransmissionEventStatusEnum.Success, value: 'Succès' },
  { key: DigitalInvoiceTransmissionEventStatusEnum.Submitted, value: 'Envoyé' },
  { key: DigitalInvoiceTransmissionEventStatusEnum.Running, value: 'En cours' },
  { key: DigitalInvoiceTransmissionEventStatusEnum.Error, value: 'Erreur' },
];

export const DigitalInvoiceTransmissionStatusLabel = {
  [DigitalInvoiceTransmissionEventStatusEnum.Success]: 'Succès',
  [DigitalInvoiceTransmissionEventStatusEnum.Submitted]: 'Envoyé',
  [DigitalInvoiceTransmissionEventStatusEnum.Running]: 'En cours',
  [DigitalInvoiceTransmissionEventStatusEnum.Error]: 'Erreur',
};

interface IEntityForInvoiceTransmission {
  id: number;
  code: string;
  name: string;
  client_code: string;
  description: string;
  parent?: ITinyEntity;
  invoice_group_tag?: string;
}

interface IDigitalInvoiceForInvoiceTransmissionDetail {
  id: number;
  code: string;
  date: string;
  entity: IEntityForInvoiceTransmission;
}

export interface IDigitalTransmissionStats {
  total_count: number;
  running_count: number;
  error_count: number;
  submitted_count: number;
  success_count: number;
}

export interface IDigitalInvoiceEvent {
  id: number;
  created_at: string;
  created_by: string;
  start_date: string;
  end_date?: string;
  status: DigitalInvoiceTransmissionEventStatusEnum;
  message?: string;
  initial_response?: string;
  transaction_id?: string;
}

export interface IDigitalInvoiceTransmission {
  id: number;
  created_at: string;
  created_by: string;
  invoices: IDigitalInvoiceForInvoiceTransmissionDetail[];
  events: IDigitalInvoiceEvent[];
  latest_event?: IDigitalInvoiceEvent;
  customer_group?: IDigitalInvoiceCustomerGroup;
  stats?: IDigitalTransmissionStats;
  can_resend?: boolean;
}

export interface IDigitalInvoiceTransmissionItem {
  id: number;
  created_at: string;
  created_by: string;
  invoice: IInvoice;
  transmission: IDigitalInvoiceTransmission;
  status: string;
  remote_status: string;
  remote_status_last_polled_at: string;
}

export interface IDigitalInvoiceCustomerGroup {
  id: number;
  created_at: string;
  created_by: string;
  entity: ITinyEntity;
  stats?: IDigitalTransmissionStats;
  transmission_count?: number;
  transmissions: IDigitalInvoiceTransmission[];
  company_group?: IDigitalInvoiceCompanyGroup;
  group_status?: string;
  can_resend?: boolean;
}

export interface IDigitalInvoiceCompanyGroup {
  id: number;
  created_at: string;
  created_by: string;
  company: ITinyCompanies;
  transmission_count?: number;
  stats?: IDigitalTransmissionStats;
  customer_group_count?: number;
  customer_groups?: IDigitalInvoiceCustomerGroup[];
  can_resend?: boolean;
}
